import { render, staticRenderFns } from "./MainLedgerDetailIndex.vue?vue&type=template&id=1fdd8cbe&scoped=true"
import script from "./MainLedgerDetailIndex.vue?vue&type=script&lang=js"
export * from "./MainLedgerDetailIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdd8cbe",
  null
  
)

export default component.exports